import { connect, compose, bindActionCreators, loadable, partialRight } from '../dependencies';
import Restaurants from '../components/Restaurants';
import { restaurantsIsFetchingSelector, selectedRestaurantsSelector } from '../services/selectors';
import { toggleRestaurantFavourite } from '../services/actions';

const mapStateToProps = state => ({
    showLoader: restaurantsIsFetchingSelector(state),
    restaurants: selectedRestaurantsSelector(state),
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            toggleRestaurantFavourite,
        },
        dispatch,
    );

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    partialRight(loadable, 'Načítám restaurace'),
)(Restaurants);
